import type { LocationLocalizedNames } from "@/db/definitions";
import { sql, type SQLWrapper } from "drizzle-orm";

export type LocalizedLocationNameSource = {
  name: string;
  localizedNames?: LocationLocalizedNames | null;
};

export const resolveLocalizedLocationName = (
  location: LocalizedLocationNameSource,
  locale: string,
) => {
  const localizedName =
    location.localizedNames?.[locale as keyof LocationLocalizedNames];

  return (
    localizedName?.trim() ||
    location.localizedNames?.en?.trim() ||
    location.name
  );
};

export const getRequiredLocalizedLocationName = (
  localizedNames: LocationLocalizedNames | null | undefined,
  locale: string,
) => {
  const localizedName =
    localizedNames?.[locale as keyof LocationLocalizedNames]?.trim();

  if (!localizedName) {
    throw new Error(`Missing localized location name for locale "${locale}".`);
  }

  return localizedName;
};

export const localizedLocationNameSql = (
  nameColumn: SQLWrapper,
  localizedNamesColumn: SQLWrapper,
  locale: string,
) =>
  sql<string>`coalesce(nullif(btrim(${localizedNamesColumn} ->> ${locale}), ''), nullif(btrim(${localizedNamesColumn} ->> 'en'), ''), ${nameColumn})`;
